import axios from 'axios';

import Opportunity from '../models/SFModels/Opportunity';
import Stage from '../models/Stage';

const API_URL =
  process.env.REACT_APP_ENV === 'local'
    ? `${process.env.REACT_APP_API_LOCAL}/salesforce/opportunity`
    : process.env.REACT_APP_ENV === 'production'
      ? `${process.env.REACT_APP_API_PRODUCTION}/salesforce/opportunity`
      : `${process.env.REACT_APP_API_STAGING}/salesforce/opportunity`;

const opportunityApi = {
  fetchOpportunity(params) {
    return axios.get(`${API_URL}${params}`).then(response => {
      const {
        id,
        name,
        pointOfSalesAlreadyUsed,
        pointOfSalesUsed,
        newOpen,
        installationDate,
        installationComment,
        calendlyLinkCsm,
        contactName,
        contactFirstName,
        contactEmail,
        stageValue,
        licenceDuration,
      } = response.data;
      return new Opportunity(
        id,
        name,
        pointOfSalesAlreadyUsed,
        pointOfSalesUsed,
        newOpen,
        installationDate,
        installationComment,
        calendlyLinkCsm,
        contactName,
        contactFirstName,
        contactEmail,
        stageValue,
        0,
        licenceDuration,
      );
    });
  },

  updateOpportunity(params, opportunityUpdated) {
    return axios
      .put(`${API_URL}?opportunityId=${params}`, opportunityUpdated, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(response => {
        return response.data;
      });
  },

  updateOpportunityStage(params, opportunity) {
    const opportunityId = opportunity;
    const stage = new Stage(opportunityId, params);
    return axios.put(`${API_URL}/stage?opportunityId=${opportunity}`, stage, {
      headers: { 'Content-Type': 'application/json' },
    });
  },
};

export default opportunityApi;



// WEBPACK FOOTER //
// ./src/api/opportunity.js